{/* DRAFT - needs lawyer review before relying on it. */}

const Section = ({ title, children }) => (
  <div className="mt-10">
    <h2 className="font-serif text-2xl font-medium tracking-tight text-walnut">{title}</h2>
    <div className="mt-3 space-y-3 text-base leading-relaxed text-umber/90">{children}</div>
  </div>
);

const LegalShell = ({ title, updated, children }) => (
  <div className="min-h-screen bg-cream font-sans text-walnut antialiased">
    <div className="mx-auto max-w-3xl px-6 py-16 lg:py-24">
      <a
        data-testid="legal-back-link"
        href="#/"
        className="font-mono text-xs uppercase tracking-[0.25em] text-terracotta transition-colors hover:text-terracotta-dark"
      >
        ← Back to The Quarterly Pulse
      </a>
      <h1 className="mt-8 font-serif text-4xl font-medium tracking-tight sm:text-5xl">{title}</h1>
      <p className="mt-3 font-mono text-xs uppercase tracking-[0.2em] text-clay">Last updated: {updated}</p>
      {children}
      <p className="mt-14 border-t border-line pt-6 text-sm text-clay">
        Questions? Email us at{" "}
        <a href="mailto:thequarterlypulse@gmail.com" className="text-terracotta underline underline-offset-4">
          thequarterlypulse@gmail.com
        </a>
      </p>
    </div>
  </div>
);

export const PrivacyPage = () => (
  <LegalShell title="Privacy Policy" updated="October 2026">
    <p className="hidden">DRAFT - needs lawyer review before relying on it.</p>
    <Section title="Who we are">
      <p>
        The Quarterly Pulse is operated by The Quarterly Pulse LLC.
        You can reach us at any time at thequarterlypulse@gmail.com.
      </p>
    </Section>
    <Section title="What we collect">
      <p>When you use the request form on this site, we collect:</p>
      <p>— Your name</p>
      <p>— Your work email address</p>
      <p>— Your company name</p>
      <p>
        The site also uses basic page-view analytics (PostHog): it records which
        pages are visited. Session recording and automatic event capture are
        switched off, and it does not record clicks, page performance, or
        heatmaps. This analytics tool sets one cookie so it can count visits.
        There are no advertising cookies or trackers.
      </p>
      <p>
        Please do not paste confidential documents into the form — we share a
        secure way to send materials after we reply.
      </p>
    </Section>
    <Section title="Why we collect it">
      <p>— To reply to your enquiry and confirm scope</p>
      <p>— To send you a confirmation email when you submit the form</p>
      <p>— To understand, in aggregate, how the site is used</p>
    </Section>
    <Section title="Who it is shared with">
      <p>— Hosting: Emergent (site hosting and database)</p>
      <p>— Email: Resend (delivers our notification and confirmation emails)</p>
      <p>— Analytics: PostHog (page-view counts only)</p>
      <p>— Canva</p>
      <p>We never sell or rent your information to anyone.</p>
    </Section>
    <Section title="How long we keep it">
      <p>
        Form submissions are kept while we handle your enquiry and any work that
        follows. You can ask us to delete your details at any time and we will do
        so promptly.
      </p>
    </Section>
    <Section title="Your rights">
      <p>
        You may request a copy of the data we hold about you, ask us to correct
        it, or ask us to delete it entirely. Just email us and we will take care
        of it.
      </p>
    </Section>
  </LegalShell>
);

export const CancellationPage = () => (
  <LegalShell title="Cancellation Policy" updated="October 2026">
    <Section title="One-Off Issue">
      <p>
        You may cancel for a full refund within 24 hours of purchase, provided
        work has not yet begun. Once our team has started drafting, cancellations
        receive a 50% refund. Delivered work is non-refundable.
      </p>
    </Section>
    <Section title="Annual Core and Annual Growth">
      <p>
        Annual plans can be cancelled at any time before work begins on your next
        quarterly package. If you cancel mid-year, we refund the value of any
        packages not yet started. Work already delivered or in progress is
        non-refundable.
      </p>
    </Section>
    <Section title="How to cancel">
      <p>
        Email us at the address below with the subject line
        &ldquo;Cancellation&rdquo; and we will confirm your cancellation within
        one business day.
      </p>
    </Section>
  </LegalShell>
);
